var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 31,
    viewBox: "0 0 18 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30023 30.0613C1.9077 30.6462 2.89016 30.6462 3.49613 30.0613L16.34 17.6657C16.6275 17.3924 16.8564 17.0641 17.0129 16.6996C17.1693 16.3352 17.2499 15.942 17.2499 15.5454C17.2499 15.1488 17.1693 14.7564 17.0129 14.3919C16.8564 14.0274 16.6275 13.6991 16.34 13.4259L3.40314 0.938736C3.10953 0.659671 2.72072 0.502823 2.31566 0.500038C1.9106 0.497252 1.51965 0.649088 1.22223 0.924088C1.0749 1.05989 0.957024 1.22425 0.875884 1.40746C0.794745 1.59067 0.752079 1.78861 0.750532 1.98898C0.748985 2.18934 0.788588 2.38751 0.866889 2.57195C0.945191 2.7564 1.06051 2.92312 1.20573 3.06119L13.0461 14.4864C13.19 14.623 13.3045 14.7875 13.3828 14.9698C13.4611 15.1521 13.5015 15.3477 13.5015 15.5461C13.5015 15.7445 13.4611 15.941 13.3828 16.1233C13.3045 16.3056 13.19 16.47 13.0461 16.6066L1.30023 27.9418C1.1564 28.0782 1.04188 28.2429 0.96361 28.4251C0.88534 28.6073 0.844964 28.8032 0.844964 29.0015C0.844964 29.1998 0.88534 29.3957 0.96361 29.5779C1.04188 29.7601 1.1564 29.9248 1.30023 30.0613Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevron);
export default __webpack_public_path__ + "static/media/icon-chevron.e33b9244a936d7593234c6d7a709c990.svg";
export { ForwardRef as ReactComponent };